import { server } from "./index";

let tariffsApi = {
  get() {
    return server.get(`/payment/subscription/tariffs`);
  },
};

export { tariffsApi };
